import { ApplicationError } from "./application-error.model";

export class ServerError extends ApplicationError {    
    public static standardServerErrorMessage = "Tekniskt fel - vänligen försök igen om en liten stund.";

    constructor(status: number) {
        super(ServerError.standardServerErrorMessage, status);
    }
}